import useSWR from "swr";


type CouponSegments = {
  id: string;
  coupon: {
    id: string;
    title: string;
    explanation: string;
    notes: string;
    expiration_date: string;
    img: string;
  }
  segment_count: number;
}[]
export const useFetchRouletteCouponSegmentsByRestaurantId = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `games/roulette/restaurants/${restaurantId}/coupon/segments/` : null;
  const { data: couponSegments, error, isLoading } = useSWR<CouponSegments>(fetcherKey)
  return { couponSegments, isLoading, error };
};